// Tiny className combiner. The repo had no cn()/clsx/tailwind-merge; the ops
// component library uses this to compose conditional Tailwind classes.
// Falsy parts are dropped; no merge/dedupe (keep it dependency-free).
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}

export default cn;
